const navItems = [
    {
        link: "#about",
        text: "About"
    },
    {
        link: "#tools",
        text: "Tools"
    },
    {
        link: "#projects",
        text: "Projects"
    },
    {
        link: "#contact",
        text: "Contact"
    }
]

export default navItems;